<div ng-if="editor.isDesigning()" ng-show="isDragged" class="shadow"></div>
<c-form-element-actions ng-if="editor.isDesigning()" editor="editor" element="field"></c-form-element-actions>
<label ng-class="{selectable:editor.isDesigning()}" ng-mousedown="editor.dragBegin(field, $event)" title="{{(editor.isDesigning() ? 'move':'')|translate}}" ng-bind-html="labelText"></label>
<span class="field-description" ng-bind-html="descriptionText"></span>
<div class="competency-content" ng-show="!loading">
    <div ng-repeat="step in fieldValue.Competency.Steps | orderBy: 'Position' track by $index" class="step-header">
        <div class="step-title" ng-click="toggle(step.Id);">
            <div class="percent" title="{{step.percentage}}%"><div ng-style="{'width':step.percentage+'%'}"></div></div>
            <i class="fa fa-angle-right" ng-class="{'fa-angle-down': visible[step.Id]}"></i>
            {{step.Title}}
        </div>
        <ul c-toggle="visible[step.Id] === true">
            <li>
                <div>{{step.Description}}</div>
                <div class="step-link" ng-click="openStep(step.RegisterNode.Id)">{{'competency.step.details'|translate}}</div>
            </li>
            <li>
                <div class="step-label">{{'competency.implemented'|translate}}</div>
                <div ng-if="!editor.editable || readonly">{{step.CompletedWhen|cDate:short}}</div>
                <c-date-time-picker visible="editor.editable && !readonly" date-time-value="step.CompletedWhen" locale="" show-date-picker="true" show-time-picker="false" justify="full"/>
            </li>
            <li ng-show="references[step.Id].length">
                <div class="step-label">{{referenceTitles[step.Id]}}</div>
                <div ng-repeat="document in references[step.Id]">
                    <div class="document-container" ng-click="openDocument(document.Id)">
                        <div class="document-link">{{ document.FullRegistrationNumber }} {{document.Title}}</div>
                        <div class="document-read" ng-if="document.ReadDate">{{(readonly ? 'competency.read' : 'competency.lastRead')|translate}}: {{document.ReadDate|cDate:short}}</div>
                        <div class="document-not-read" ng-if="!document.ReadDate">{{'competency.notRead'|translate}}</div>
                    </div>
                </div>
            </li>
            <li ng-show="step.Tasks.length">
                <div class="step-label">{{taskTitles[step.Id]}}</div>
                <div ng-repeat="task in step.Tasks | orderBy: 'Position' track by $index">
                    <c-checkbox checked="task.Done" label="task.Text" enabled="editor.editable && !readonly"/>
                </div>
            </li>
        </ul>
    </div>
</div>
<div ng-show="!loading && !tool && !isValid && ((message.header && message.header.length) || (message.description && message.description.length))" class="competency-warning">
    <i class="fa fa-warning"></i> <b>{{message.header}}</b><br /><br />
    {{message.description}}
</div>
<table ng-if="tool" class="competency-toolfield-table">
    <tbody>
    <tr><td></td><td></td><td></td></tr>
    <tr><td></td><td></td><td></td></tr>
    <tr><td></td><td></td><td></td></tr>
    </tbody>
</table>
<div ng-show="!tool && loading">
    <i class="fa fa-circle-o-notch fa-spin wait-icon"></i>
    {{'competency.loading'|translate}}
</div>